import React, { createContext, useContext, useEffect, useState } from 'react';
import UiStateProvider from './UiStateProvider';
import { Stages } from '../types';

interface PathExplorerContextType {
    detailesPanelOpened: boolean;
    selectedHeader: string;
    selectedType: string;
    barChartData: any[];
    setDetailesPanelOpened: (opened: boolean) => void;
    setSelectedHeader: (headerId: string) => void;
    setSelectedType: (type: string) => void;
    setBarChartData: (data: any[]) => void;
}

const PathExplorerContext = createContext<PathExplorerContextType | undefined>(undefined);

export const PathExplorerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [detailesPanelOpened, setDetailesPanelOpened] = useState<boolean>(false)
    const [selectedHeader, setSelectedHeader] = useState<string>(null)
    const [selectedType, setSelectedType] = useState<string>(null)
    const [barChartData, setBarChartData] = useState(null)
    const { currentStage } = useContext(UiStateProvider)

    useEffect(() => {
        if(currentStage !== Stages.kg)
            setSelectedHeader(null)
    }, [currentStage])

    return (
        <PathExplorerContext.Provider value={{ detailesPanelOpened, selectedHeader, selectedType, barChartData, setDetailesPanelOpened, setSelectedHeader, setSelectedType, setBarChartData }}>
            {children}
        </PathExplorerContext.Provider>
    );
}

export default PathExplorerContext;
